/**
 * udesk IM 集成
 */
const udesk = {
  data() {
    return {
      initedUdesk: false, // 是否已经初始化过了
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initUDesk();
    });
  },
  methods: {
    // 初始化
    initUDesk() {
      const map = {
        el_GR: 'zh-TW', en_US: 'en-us', ja_JP: 'ja', ko_KR: 'ko', zh_CN: 'zh-cn',
      };
      const locale = localStorage.getItem('locale') || 'en_US';
      if (window.ud && !this.initedUdesk) {
        window.ud({
          mode: 'inner',
          language: map[locale],
          targetSelector: '.footer-udesk',
          selector: '#udesk',
          mobile: { // 为响应式布局，提供pc、mobile自定制
            mode: 'blank',
            language: map[locale],
          },
        });
        window.ud('init');
        this.initedUdesk = true;
      }
      // 不自动弹出对话框
      if (window.ud) {
        window.ud('hidePanel');
      }
    },
  },
};

export default udesk;
